module.exports = __webpack_public_path__ + "img/logo.78ce9b44.png";